<template>
  <a
    v-if="selected"
    @click="onClick(display_url, title)"
    class="picture-thumbnail selected p-1 ml-1 mr-1 mb-2"
  >
    <img v-bind:src="url" style="border-radius: 5px;" v-bind:alt="title" />
  </a>
  <a
    v-else
    @click="onClick(display_url, title)"
    class="picture-thumbnail  p-1 ml-1 mr-1 mb-2"
  >
    <img v-bind:src="url" style="border-radius: 5px;" v-bind:alt="title" />
  </a>
</template>

<script>
export default {
  name: "Thumbnail",
  props: ["url", "display_url", "title", "selected"],
  methods: {
    onClick(display_url, title) {
      this.$emit("select-thumbnail", display_url, title);
    },
  },
};
</script>
<style scoped>
.picture-thumbnail {
  cursor: pointer;
}
</style>
